import { styled } from "@mui/material";
import Box from "@mui/material/Box";

export const PopoverBox = styled(Box)(({ theme }) => ({
  minWidth: theme.spacing(24),
  maxWidth: theme.spacing(36),
}));
